module.exports = __webpack_public_path__ + "media/nb_no_s4_Kaari.dfcd7a5f.oga";